import KpiTile from 'components/KpiTile';
import WithResponsive from 'components/WithResponsive';
import FourSplitContainer from 'components/containers/FourSplitContainer';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const KpiTiles: FunctionComponent<Props> = ({ className = '', items, testId = TEST_ID }) => (
    <WithResponsive>
        <FourSplitContainer className={className} testId={testId}>
            {items.map(({ key, subtext, title, value }) => (
                <KpiTile key={key} subtext={subtext} title={title} value={value} />
            ))}
        </FourSplitContainer>
    </WithResponsive>
);

export default KpiTiles;
